/**
 * 消息中心路由
 * Bai.Zhiming
 * 2019-6-25
 */
angular.module("messageCenterRouterModule", []).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("front.mc", {
        url: '/mc',
        views: {
            'main@front': {
                templateUrl: './MC/messageCenter_tpl.html',
                controller: 'messageCenterCtrl'
            },
            'left@front.mc': {
                templateUrl: './MC/left/left_tpl.html',
                controller: 'messageCenterLeftCtrl'
            }
        }
    })
}])